import { BepoFloatingPlayerController } from "../../../radioWidgets/bepoFloatingPlayer/bepoFloatingPlayerController";
import { ProcessedAudioArticlesRecommendationsItem } from "../audioArticlesRecommendationsUtils";

interface AudioArticlesRecommendationsPlayerProps {
    item: ProcessedAudioArticlesRecommendationsItem;
    domain?: string;
    isMobileWeb: boolean;
    onClose: () => void;
}

export class AudioArticlesRecommendationsPlayer extends React.Component<AudioArticlesRecommendationsPlayerProps, {}> {
    render() {
        const { item, domain, isMobileWeb, onClose } = this.props;
        const duration = item.hasVideo && item.videoData && item.videoData.duration
            ? item.videoData.duration
            : (item.duration || 0);

        return (
            <BepoFloatingPlayerController
                key={item.id || item.articleId}
                title={item.title}
                podcastName={item.categoryName || ""}
                podcastImageUrl={item.categoryIconSrc || ""}
                podcastPageUrl={item.link || ""}
                bepoHomeUrl={domain ? domain + "/tags/bepo" : ""}
                audioUrl={item.audioUrl || ""}
                videoData={item.videoData}
                hideVideoAds={item.hideVideoAds}
                mediaImageUrl={item.imageUrl || ""}
                duration={duration}
                isMobileWeb={isMobileWeb}
                onClose={onClose}
            />
        );
    }
}
